// Perzistence „viděno" pro průvodce okny — drží se v localStorage (jako historie otevřených oken),
// aby se průvodce automaticky zobrazil jen tomu, kdo ho ještě neviděl. Po reloadu/odhlášení zůstává.

const STORAGE_KEY = 'phx:window-onboarding:v1';

interface OnboardingState {
  /** Uživatel průvodce dokončil nebo přeskočil (→ automaticky se už neotevře). */
  readonly seen: boolean;
  /** Čas dokončení/přeskočení (ms) — jen informativní. */
  readonly at?: number;
}

function read(): OnboardingState | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as unknown;
    if (parsed && typeof (parsed as OnboardingState).seen === 'boolean') {
      return parsed as OnboardingState;
    }
    return null;
  } catch {
    return null;
  }
}

function write(state: OnboardingState): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    /* localStorage nedostupné / plné — ignorujeme */
  }
}

/** Viděl už uživatel průvodce (dokončil/přeskočil)? */
export function hasSeenWindowOnboarding(): boolean {
  return read()?.seen ?? false;
}

/** Označí průvodce za viděný (uloží do localStorage). */
export function markWindowOnboardingSeen(): void {
  write({ seen: true, at: Date.now() });
}
